module.exports = __webpack_public_path__ + "static/media/ch-box-10-pressed.b8158d27.svg";